import React, {Component} from 'react'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { ButtonCard } from './../styles'
import { Bookmark, BookmarkPlain } from './'
import { addBookmark, removeBookmark } from '../store/actions/Content'


class BookmarkButton extends Component {
  state = {
    isBooked: false,
    isLoad: false,
  }

  componentDidMount() {
    this.setState({ isBooked: this.props.is_bookmark })
  }

  componentWillReceiveProps({is_bookmark}){
    if (is_bookmark !== this.state.isBooked) {
      this.setState({ isBooked: is_bookmark })
    }
  }

  handlerClick = (e) => {
    e.preventDefault()
    e.stopPropagation()
    this.setState({isBooked: !this.state.isBooked}, () => {
      this.state.isBooked ? this.props.addBookmark(this.props.item) : this.props.removeBookmark(this.props.item)
    })
  }

  static defaultProps = {
    big: false,
  }

  render() {
    const { isBooked } = this.state
    const { big } = this.props
    return (
      <button className={`btn btn-bookmark ${ButtonCard(big)}`} onClick={this.handlerClick}>
        <span className="btn--label">
          { !isBooked ? <Bookmark width={24} height={24} /> :  <BookmarkPlain width={24} height={24} /> }
        </span>
      </button>
    )
  }
}

export default connect(
  null,
  dispatch => ({
    addBookmark: compose(dispatch, addBookmark),
    removeBookmark: compose(dispatch, removeBookmark)
  })
)(BookmarkButton)


// WEBPACK FOOTER //
// ./src/components/BookmarkButton.js